import React from 'react';
import Image from '../../../components/AppImage';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-background">
      <div className="w-full max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-12 items-center">
          {/* Profile Image */}
          {/* <div className="order-2 lg:order-1 flex justify-center lg:justify-start">
            <div className="relative">
              <div className="w-80 h-80 rounded-2xl overflow-hidden shadow-elevation-3">
                <Image
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face"
                  alt="John Doe - Full Stack Developer"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary rounded-full flex items-center justify-center shadow-elevation-2">
                <span className="text-white font-bold text-lg">5+</span>
              </div>
            </div>
          </div> */}

          {/* About Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="space-y-4">
              <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
                About Me
              </h2>
              <div className="w-20 h-1 bg-primary rounded-full"></div>
            </div>

            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p className="text-lg">
              With two years of hands-on experience in startups, I have cultivated a robust skill set as a MERN Stack Developer, proficient in React, Node.js, Nest.js, Next.js, MongoDB, and MySQL. I thrive in dynamic environments and excel in delivering scalable solutions that adhere to industry standards.
              </p>
              
              <p>
              My current focus on AWS and containerization underscores my commitment to staying ahead in modern development. By embracing cloud technologies and DevOps practices, I ensure that my solutions are not only efficient but also future-ready.
              </p>
              
              <p>
              Driven by a dedication to excellence, I approach every project with enthusiasm, whether it involves system architecture, database optimization, or UI design. I enjoy breaking down complex problems and creating clean, practical solutions that add real value.
              </p>
              <p>
              My journey reflects adaptability and an unwavering pursuit of growth. I am eager to leverage my skills in contributing to transformative projects across diverse domains, while continuously pushing myself to innovate and excel.
              </p>
            </div>

            {/* Key Highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6">
              <div className="space-y-2">
                <h4 className="font-semibold text-foreground">Specialization</h4>
                <p className="text-sm text-muted-foreground">MERN Stack Development</p>
              </div>
              <div className="space-y-2">
                <h4 className="font-semibold text-foreground">Experience</h4>
                <p className="text-sm text-muted-foreground">2+ Years Professional</p>
              </div>
              <div className="space-y-2">
                <h4 className="font-semibold text-foreground">Location</h4>
                <p className="text-sm text-muted-foreground">Lucknow, IN</p>
              </div>
              <div className="space-y-2">
                <h4 className="font-semibold text-foreground">Availability</h4>
                <p className="text-sm text-muted-foreground">Open to Opportunities</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;